export default __webpack_public_path__ + "static/media/plane-circle-filled.56aa7f62.svg";